var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.39248 14.5541C3.65809 13.7196 2.92372 12.8517 2.45637 11.8169C1.98905 10.7153 1.85551 9.44683 2.08919 8.24512C2.32287 7.0434 2.85694 5.90844 3.62473 4.9404C3.55797 5.77493 3.8584 6.64283 4.42587 7.27708C4.09205 5.67479 4.62616 3.93897 5.69434 2.6705C6.76252 1.40203 8.2313 0.567466 9.76681 0C8.99906 0.801144 8.89891 2.06961 9.19934 3.13782C9.49977 4.20601 10.134 5.14068 10.7015 6.10872C11.269 7.07676 11.8031 8.07819 11.8365 9.17976C12.1369 8.6123 12.4707 8.0448 12.671 7.41058C12.8713 6.77633 12.9714 6.10872 12.8045 5.47447C13.4054 6.20886 13.7392 6.94323 13.9061 7.8779C14.073 8.81258 14.0396 9.78062 13.9395 10.7153C13.806 11.7501 13.5389 12.8183 12.9714 13.6862C12.3038 14.721 11.2356 15.4554 10.0673 15.856C7.99763 16.2232 5.96137 15.9227 4.39248 14.5541Z",
    fill: "#F3705A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.93203 15.7884C9.66925 16.8566 12.3731 13.6187 10.871 11.1151C10.871 11.0817 10.8376 11.0817 10.8376 11.0483C10.9711 12.4169 10.6373 13.4184 10.003 13.9859C10.3369 13.1847 10.1032 12.2501 9.70261 11.4489C9.30204 10.6812 8.73457 9.98015 8.30061 9.24576C7.86664 8.47801 7.53286 7.61008 7.73314 6.74219C6.932 7.34305 6.36453 8.24433 6.13085 9.21237C5.89718 10.1804 6.03071 11.2486 6.46467 12.1499C5.96396 11.7827 5.59678 11.1819 5.56339 10.5476C5.02928 11.1819 4.69549 12.0164 4.72885 12.8509C4.72888 14.1528 5.76367 15.3211 6.93203 15.7884Z",
    fill: "#FFD15C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlame);
export default __webpack_public_path__ + "static/media/flame.df0a47cc6118f76d6d4d6c827fc53ee5.svg";
export { ForwardRef as ReactComponent };